import { render, staticRenderFns } from "./ModalSeller.vue?vue&type=template&id=5c6f4e58&scoped=true&"
import script from "./ModalSeller.vue?vue&type=script&lang=js&"
export * from "./ModalSeller.vue?vue&type=script&lang=js&"
import style0 from "./ModalSeller.vue?vue&type=style&index=0&id=5c6f4e58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6f4e58",
  null
  
)

export default component.exports